import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SubcategoryModal.css';
import Icon from './Icon';

export default function SubcategoryModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const subcategories = [
    { name: 'Vort', slug: 'vort' },
    { name: 'Tenoyem', slug: 'tenoyem' },
    { name: 'Bavarfen', slug: 'bavarfen' },
    { name: 'Wedding', slug: 'wedding' },
    { name: 'Sheva Bruches', slug: 'sheva-bruches' },
  ];

  const handleSubcategoryClick = (slug) => {
    onClose();
    navigate(`/categories/its-a-shidduch/${slug}`);
  };

  return (
    <div className="subcategory-modal-overlay" onClick={onClose}>
      <div className="subcategory-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="subcategory-modal-close" onClick={onClose} aria-label="Close"><Icon name="close" size="26px" /></button>

        <h2 className="subcategory-modal-title">It's a Shidduch</h2>

        <div className="subcategory-grid">
          {subcategories.map((subcat) => (
            <div
              key={subcat.slug}
              className="subcategory-card-wrapper"
              onClick={() => handleSubcategoryClick(subcat.slug)}
            >
              <div className="subcategory-card">
                <span className="subcategory-card-text">{subcat.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
